import EfBarLeft from '@elem/ui/ef-bar-left';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.BarL');
    // 打开弹窗
    const openHandle = () => editorEventsBus.emit('globalWin-SignupPopup');

    return (
        <div className={styles.TheComp}>
            <EfBarLeft
                isShowTimes={5}
                pc="https://websiteoss.ecoflow.com/upload/image/1722568869849/email-icon.png"
                title={t('l_title')}
                desc={t('l_desc')}
                callback={openHandle}
            />
        </div>
    );
}
